module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headeracknow01",
      "epub:type": "acknowledgments",
      "id": "acknow",
      "role": "doc-acknowledgments"
    }
  }, [_c('header', {
    attrs: {
      "id": "headeracknow01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "viii",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ix",
      "id": "pix",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsutvmgoodplace0008#racknow"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("E")]), _vm._v("ndless gratitude for those who helped this book be, including Stacey Abbott, for early advice on the process; the Science Fiction and Fantasy section of the Southwest Popular and American Culture Association, for discussion and ideas; Tamy Burnett, for helping turn an offhanded comment during a panel into what would become the book’s first chapter; Kristopher Woofter, for encouragement and discussion; Marie Sweetman, for editorial prowess and thoughtfulness; and Carol Giannini, for support.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1781a5c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-tvmgoodplace-0009.vue
// module id = 78
// module chunks = 0